<template>
  <form v-on:submit.prevent="editProduct">
      <div class="modal-card">
          <header class="modal-card-head" style="background:#222">
              <p class="modal-card-title" style="color:white"><span style="color: #7cda24">Edit</span> {{product.title}}</p>
          </header>
          <section class="modal-card-body">
              <b-field label="Product Name">
                  <b-input
                      type="text"
                      v-model="product.title"
                      placeholder 
                      >
                  </b-input>
              </b-field>

              <b-field label="Product Categories">
                <b-input v-model="product.categories" placeholder  ></b-input>
              </b-field>
              <b-field label="Price">
                <b-input v-model="product.price" placeholder></b-input>
              </b-field>
              <b-field label="In Stock">
                <b-input  v-model="product.inStock"></b-input>
              </b-field>
              
              <b-field label="Description">
                <b-input type="textarea" v-model="product.desc"></b-input>
              </b-field>

          </section>
          <footer class="modal-card-foot">
              <button class="button is-primary is-outlined" type="submit">Save Changes</button>
              <button class="button is-dark" type="button" @click="$parent.close">Close</button>
          </footer>
      </div>
  </form>
</template>

<script>
import { ucFirst, currencies, ls } from '@/helpers';
import { mapGetters } from 'vuex';
import decode from 'jwt-decode'

export default {
  name: "EditProductModal",
  data() {
      return {
      }
  },
  props: ['product'],
  computed: {
      userAuth() {
        return ls('token') ? decode(ls('token')) : null;
      },
      isAdmin() {
        return this.userAuth ? this.userAuth.subject === "admin" : false;
      },
      isProvincialManager() {
        return this.userAuth ? this.userAuth.type === "provincial-manager" : false;
      },
  },
  created() {
  },
  methods: {
      editProduct() {
        const loading = this.$loading.open();
        this.$store.dispatch('editProduct', this.product).then(() => {
          console.log(this.product)
          loading.close();
          this.$parent.close();
          this.$toasted.global.success(`Product Successfully Updated!`);
          this.$emit('reload');
        }).catch(e=> {
          loading.close();
          console.log('Exception when editing product',e);
          this.$toasted.global.error('Failed to save changes. Please try again.');
        })
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Shop/EditProductModal.vue